export const DRV2 = 'DRV2';
export const DRV3 = 'DRV3';
export const ORTHO = 'ORTHO_PREP_TASK';
export const INFERENCE_CPU = 'INFERENCE_CPU_TASK';

export const DRV2_TASK_CHAINING = 'DRV2_TASK_CHAINING';
export const INFERENCE = 'INFERENCE';
